import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'
import echarts from 'echarts'

window.API = api
console.log(process.env.NODE_ENV)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.config.API = API

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
